module.exports = __webpack_public_path__ + "static/img/6-2.6b9e7e71.png";